import ColorThief from 'sunzi-color-thief/dist/color-thief.mjs';
import { loadHTMLImage } from '.'

/** 获取图片调色板 */
export const getImageColor = async (source: string) => {
  const image = await loadHTMLImage(source);
  const colors = new ColorThief().getPalette(image);
  if (colors) // 降低30%饱和度
    return colors.map((item: [ number, number, number ]) => {
      let { h, s, v } = rgb2hsv(...item);
      s *= 0.7;
      return hsv2rgb(h, s, v);
    });
  return [];
}

/** HSV 转成 RGB */
export const hsv2rgb = (h: number, s: number, v: number) => {
  h /= 360, s /= 100, v /= 100;
  let r = 0, g = 0, b = 0;
  let i, f, p, q, t;
  i = Math.floor(h * 6);
  f = h * 6 - i;
  p = v * (1 - s);
  q = v * (1 - f * s);
  t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0: r = v, g = t, b = p; break;
    case 1: r = q, g = v, b = p; break;
    case 2: r = p, g = v, b = t; break;
    case 3: r = p, g = q, b = v; break;
    case 4: r = t, g = p, b = v; break;
    case 5: r = v, g = p, b = q; break;
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };
}

/** RGB 转成 HSV */
export const rgb2hsv = (r: number, g: number, b: number) => {
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b),
    d = max - min;
  let h = 0,
    s = max === 0 ? 0 : d / max,
    v = max / 255;

  switch (max) {
    case min: h = 0; break;
    case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
    case g: h = (b - r) + d * 2; h /= 6 * d; break;
    case b: h = (r - g) + d * 4; h /= 6 * d; break;
  }
  h *= 360, s *= 100, v *= 100;
  return { h, s, v };
}
